import { render, staticRenderFns } from "./PIcon.vue?vue&type=template&id=44724734"
import script from "./PIcon.vue?vue&type=script&lang=js"
export * from "./PIcon.vue?vue&type=script&lang=js"
import style0 from "./PIcon.vue?vue&type=style&index=0&id=44724734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports